import React from 'react';
import { InputText } from 'primereact/inputtext';

interface SocialInputProps {
  icon: string;
  prefix?: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
}

export const SocialInput: React.FC<SocialInputProps> = ({
  icon,
  prefix,
  placeholder,
  value,
  onChange,
}) => {
  return (
    <div className="p-inputgroup">
      <span className="p-inputgroup-addon">
        <i className={icon}></i>
      </span>
      {prefix && <span className="p-inputgroup-addon">{prefix}</span>}
      <InputText
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};
